module.exports = __webpack_public_path__ + "img/control_main1.93bf1258.png";